// extracted by mini-css-extract-plugin
export default {"container":"BioContainer_container__93xV+"};